import { Suspense } from 'react';
import { SuspenseLoader } from './SuspenseLoader';

export const SuspenseWrapper = ({
  children,
  fallback,
}: {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}) => {
  return (
    <Suspense fallback={fallback || <SuspenseLoader />}>{children}</Suspense>
  );
};
